export default __webpack_public_path__ + "static/media/call-outgoing.8d046f82.svg";